import React from 'react';
import {
  Icon,
  TranslationProvider,
} from '@resy/ui-kitchen';

import Question from '../../../images/icons/question.svg';

export default function RSVPNotFound() {
  return (
    <div className="ResyInviteRsvp__head">
      <div className="ResyInviteRsvp__icon">
        <Icon className="ResyIcon" iconClass="ResyIcon" component={Question} aria-hidden="true" />
      </div>
      <TranslationProvider
        translationKey="invite_not_found_header"
      >
        <h2 className="ResyInviteRsvp__title">
          Invite Not Found
        </h2>
      </TranslationProvider>
      <TranslationProvider
        translationKey="invite_not_found_subtitle"
      >
        <div className="ResyInviteRsvp__subtitle">
          Did you wait a while to RSVP? If so, the link may have expired. Ask your friend to send again.
        </div>
      </TranslationProvider>
      <TranslationProvider
        translationKey="invite_declined_body"
      >
        <div className="ResyInviteRsvp__blurb">
          Please
          <a href="mailto:help@resy.com">email us</a>
          {' '}
          if you have any questions.
        </div>
      </TranslationProvider>
    </div>
  );
}
